import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
interface BuildersSkillsSkeletonProps {
  builderSkillsWidth: number;
}
function BuildersSkillsSkeleton(t0) {
  const $ = _c(2);
  const {
    builderSkillsWidth
  } = t0;
  const t1 = `${builderSkillsWidth * 4}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Skeleton className="h-6" style={{
      width: t1
    }} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
export { BuildersSkillsSkeleton };